"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, UnstyledButton } from "@opensea/ui-kit";
import { Menu, OpenSeaBrandLogo, OpenSeaHalloweenLogo, OpenSeaLetters } from "@opensea/ui-kit/icons";
import { HomeLink } from "@/components/home/HomeLink";
import { Notifications } from "@/components/notifications/Notifications";
import { useIsHalloweenLogoEnabled } from "@/hooks/use-flags";
import { MobileNavSearch } from "../MobileNavSearch";
import { MoreMenuSheet } from "../more-menu/MoreMenuSheet";
import { ConnectIconButton } from "./ConnectIconButton";
import { DesktopNavbarContainer } from "./DesktopNavbarContainer";
import { MobileNavbarContainer } from "./MobileNavbarContainer";
import { NavSearch } from "./NavSearch";
import { UserControls } from "./UserControls";
export function TopNavbar() {
  const $ = _c(12);
  const isHalloweenLogoEnabled = useIsHalloweenLogoEnabled();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MoreMenuSheet><UnstyledButton><Menu /></UnstyledButton></MoreMenuSheet>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isHalloweenLogoEnabled) {
    t1 = isHalloweenLogoEnabled ? <OpenSeaHalloweenLogo size={30} /> : <OpenSeaBrandLogo size={30} />;
    $[1] = isHalloweenLogoEnabled;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <OpenSeaLetters className="translate-y-0.5" width={97} />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <FlexCenter className="gap-2.5">{t0}<HomeLink variant="unstyled"><FlexCenter className="gap-2.5">{t1}{t2}</FlexCenter></HomeLink></FlexCenter>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FlexCenter className="gap-4"><MobileNavSearch /><Notifications iconSize={24} showCount={false} /><ConnectIconButton /></FlexCenter>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3) {
    t5 = <MobileNavbarContainer>{t3}{t4}</MobileNavbarContainer>;
    $[7] = t3;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DesktopNavbarContainer><div className="min-w-0 flex-1"><NavSearch /></div><UserControls /></DesktopNavbarContainer>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5) {
    t7 = <>{t5}{t6}</>;
    $[10] = t5;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}